import React from "react";
import { Handshake, Banknote, ShieldCheck, Package, Landmark, CreditCard } from "lucide-react";

export function HandDeliveryBadge({ compact = false, className = "", national = false, acceptsCard = false }) {
  const base = `flex flex-wrap items-center gap-x-4 gap-y-1.5 border border-neon-green/60 bg-neon-green/10 px-3 ${compact ? "py-2 text-xs" : "py-2.5 text-sm"} ${className}`;
  if (national) {
    return (
      <div data-testid="hand-delivery-badge" className={base}>
        <span className="flex items-center gap-1.5 text-neon-green font-anton uppercase tracking-wide"><Package className="h-4 w-4" /> Colis discret 24/48h · France entière</span>
        <span className="flex items-center gap-1.5 text-zinc-200 font-semibold"><Landmark className="h-4 w-4 text-neon-magenta" /> Paiement par virement instantané</span>
        <span className="flex items-center gap-1.5 text-zinc-400"><ShieldCheck className="h-4 w-4 text-neon-green" /> Expédié dès réception du virement</span>
      </div>
    );
  }
  return (
    <div data-testid="hand-delivery-badge" className={base}>
      <span className="flex items-center gap-1.5 text-neon-green font-anton uppercase tracking-wide"><Handshake className="h-4 w-4" /> Livraison en main propre</span>
      <span className="flex items-center gap-1.5 text-zinc-200 font-semibold">{acceptsCard ? <CreditCard className="h-4 w-4 text-neon-magenta" /> : <Banknote className="h-4 w-4 text-neon-magenta" />} {acceptsCard ? "Paiement à la remise : carte sans contact ou espèces" : "Paiement à la remise : espèces"}</span>
      <span className="flex items-center gap-1.5 text-zinc-400"><ShieldCheck className="h-4 w-4 text-neon-green" /> Rien à payer en ligne</span>
    </div>
  );
}
